import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList, FormatListNumbered,ConfirmationNumber,HourglassEmpty,Check,Close} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Link,
  Slide
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService,ReportingService,AdminService,FinanceService} from "./../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},
paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    height:300,
    elevation:0
  },appBar: {
    position: 'relative',
  },title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
}));




// export const user_performance= 
// {options:{
//     series: [],
//     chart: {
//     width: 380,
//     type: 'pie',
//   },
  
//   labels: [],
//   legend: {
//     position: 'right',
//     itemMargin:{
//         horizontal:0
//     }
//   },
//   responsive: [{
//     breakpoint: 480,
//     options: {
//       chart: {
//         width: 280,
//         height:280
//       },
//       legend: {
//         position: 'right'
//       }
//     }
//   }]
//   }
// }
// ;




 function ReportUserOld() {
  const classes = useStyles1();

  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [reportsMessage,setReportsMessage]=useState("Loading...");
  const [reportTitle,setReportTitle]=useState("User Daily report");

  const [currency,setCurrency]=useState("RWF");

  const history = useHistory();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


//offenses table 


const columns = [
  {
    name: "cashier",
    label: "Cashier",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="primary"><Link href="#" onClick={()=>{
        setPosUser(value);
        get_details(value);
      }}>
        {value}
      </Link>
      </Typography>
      );
   }
    }
   } 
   ,
     {
   name: "passengr_cash",
   label: "Cash",
   options: {
    filter: true,
    sort: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="secondary">{formatMoney(value,0)}
      </Typography>
      );
   }
   }
  },
  
     {
   name: "passenger_card",
   label: "Card",
   options: {
    filter: true,
    sort: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="secondary">{formatMoney(value,0)}
      </Typography>
      );
   }
   }
  },

  {
    name: "luggage_cash",
    label: "Luggage Cash",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="secondary">{formatMoney(value,0)}
      </Typography>
      );
   }
    }
   },

     {
   name: "total_tickets",
   label: "Total tickets",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "amount",
   label: "Total amount",
   options: {
    filter: true,
    sort: true,
   }
  }


//    {
//     name: "status",
//     label: "Status",
//     options: {
//      filter: true,
//      sort: false,
//      customBodyRender: (value, tableMeta, updateValue) => {
//          if(value=="USED"){
//             return (
//                 <Chip
//                 color={"primary"}
//                 label={value}
//                 icon={<Check />}
//               ></Chip>
                  
//               );
//          }else{
//             return (
//                 <Chip
//                 color={"secondary"}
//                 label={value}
//                 icon={<HourglassEmpty />}
//               ></Chip>
                  
//               );
//          }
        
//       }
//     }
//    }
 ];

 
 const options = {textLabels: {
  body: {
    noMatch: reportsMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0
 };


 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);


  get_user_report(data.token);
  get_pos_user(data.token);

 },[]);

 const getDate=()=>{
    return Format(new Date(), ["yyyy-MM-dd",]);
 }


 const [amounts,setAmounts]=useState([]);
 const [labels,setLabels]=useState([]); 
 const [revenue,setRevenue]=useState([]);


 const user_performance= 
{options:{
    series: [],
    chart: {
    width: 380,
    type: 'pie',
  },
  
  labels: labels,
  dataLabels: {
    enabled: false
  },
  legend: {
    position: 'left',
    horizontalAlign:"left",
    // itemMargin:{
    //     horizontal:0
    // }
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 280,
        height:280
      },
      legend: {
        position: 'left'
        
      }
    }
  }]
  }
}




const revenue_user=
{
    options:{
        series: [{
        name: 'Revenue',
        data: revenue
      }],
        chart: {
        height: 350,
        type: 'bar',
        tools:{
            download: false,
            selection:false,
            pan:false,
            reset:false,
          }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          distributed: false,
          startingShape: "flat",
          columnWidth: '5px',
          dataLabels: {
            enabled: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val + " ";
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#304758"]
        }
      },
      
      xaxis: {
        categories: labels ,
        position: 'bottom',
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            }
          }
        },
        tooltip: {
          enabled: true,
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val + " ";
          }
        }
      
      },
      
      }
};



 // get pos user
 const [users,setUsers]=useState([]);
 const get_pos_user=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const usersInstance = axios.create(new TransportService().setHeaders(token));
    usersInstance.get('/api/v1/integrations/getUsersByOrganization/'+new UserInfo().ORG_ID
    ).then(res=>{

      console.log("pos users",res.data);
      var d=res.data;
      if(d.length==0){
        enqueueSnackbar("No POS user available", { 
          variant: 'info',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }else{
        var dd=d.filter((x)=>x.user_type=="POS_USER");
        if(dd.length==0){
          enqueueSnackbar("No POS user available", { 
            variant: 'info',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }else{
            setUsers(dd);
        }
       
      }
    }).catch(err=>{

      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    });
 }



 // summary 

 const [totalTickets,setTotalTickets]=useState(0);
 const [totalAmount,setTotalAmount]=useState(0);


//  get reports
const [reportLoad,setReportLoad]=useState(false);
const [reports,setReports]=useState([]);

const get_user_report=(token)=>{
  setReportLoad(true);
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const reportInstance = axios.create(new ReportingService().setHeaders(token));
  reportInstance.post('/pos-report/user-daily-ticket-old',{
    "company_id":new UserInfo().ORG_ID,
    "organization_id":new UserInfo().ORG_ID,
    // "end_date": "2021-09-12 23:59:59",
    // "start_date": "2021-08-12 00:00:00"
    "end_date": Format(new Date(), ["yyyy-MM-dd",])+" 23:59:59",
    "start_date": Format(new Date(), ["yyyy-MM-dd",])+" 00:00:00"
  })
  .then(res=>{
    
    setReportLoad(false);
    var objs=res.data.data;
    var curr="";
    if(objs.length==0){
      setReportsMessage("No User report available");
    }else{
      var tot=0;
      var tic=0;
      var u=[];
      objs.map((o)=>{
        // o['amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency'];
        o['amount']=formatMoney(parseInt(o['total_amount']),0)+" RWF";
        tot=tot+parseInt(o['total_amount']);
        tic=tic+parseInt(o['total_tickets']);
        // o['total_amount']=o['total_amount']+" "+o['currency'];
        o['total_amount']=o['total_amount']+" RWF";
        // if(o['cashier']==null){
        //   o['cashier']="No Cashier";
        // }
        if(o['cashier']==null){
          o['cashier']=o["user_name"];
        }
        
        // else{
        //   o['cashier']=o["user_name"];
        // }
        // curr=o['currency'];
        u.push(o['cashier']);
      });



      let unique_pos =u.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      let unique_percentage=[];
      let unique_revenue=[];
     
      for(var i=0;i<unique_pos.length;i++){
        var to=0
        var r=0;
        for(var a=0;a<objs.length;a++){
          if(objs[a]['cashier']==unique_pos[i]){ 
            r=r+parseInt(objs[a]['total_amount']);
            to=to+parseInt(objs[a]['total_tickets']);
          }
        }
        unique_percentage.push(to);
        unique_revenue.push(r);
      }
    
      setAmounts(unique_percentage);
      setLabels(unique_pos);
      setRevenue(unique_revenue);

      // user_performance.options.series=unique_percentage;
      // user_performance.options.labels=unique_pos;

      console.log("percentage",unique_percentage);

      console.log("distinct",unique_pos);


      setTotalTickets(tic);
      setTotalAmount(tot);
      setReports(objs);

      console.log("objs",objs);
      // setCurrency(curr);
    }

  })
  .catch(err=>{
    setReportLoad(false);
    

    if(err.message){
      setReportsMessage(err.message);
      enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
    }

    if(err.response){
      setReportsMessage(err.response.data.message);
      enqueueSnackbar(err.response.data.message,
        { 
          variant: 'error'
      });
    }

  });
}



// filter report 


// filter dialog 
const [filterDialog,setFilterDialog]=useState(false);


// filter user report

const [startDate,setStartDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [endDate,setEndDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [username,setUsername]=useState({value:null,error:""});


const filter_report=()=>{
  setReportLoad(true);
  if(username.value!=null){
    setReports([]);
    setAmounts([]);
    setLabels([]);
    setRevenue([]);

    
    if(startDate.value==endDate.value){

      // one day 

      axios.defaults.baseURL = new ReportingService().BASE_URL;
      const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
      filterInstance.post('/extra-reports/pullUserReportLevelOne',
      {
        "company_id":new UserInfo().ORG_ID,
        "organization_id":new UserInfo().ORG_ID,
        "user":username.value,
        "end_date": endDate.value,
        "start_date": startDate.value,
        "username": username.value
      }
      )
   .then(res=>{
    console.log("user report",res.data.data);
    setReportLoad(false);
    setReportTitle("User: "+username.value+" Day : "+startDate.value);
    var objs=res.data.data;
    if(objs.length==0){
      
      setTotalAmount(0);
      setTotalTickets(0);
      setReportsMessage("No User report available");
      setFilterDialog(false);
    }else{
      var tot=0;
      var tic=0;
      var u=[];
      
      objs.map((o)=>{
        o['amount']=formatMoney(parseInt(o['total_amount']),0)+" RWF";
        tot=tot+parseInt(o['total_amount']);
        tic=tic+parseInt(o['total_tickets']);
        o['total_amount']=o['total_amount']+" RWF";
        o['user_name']=username.value;
        o['cashier']=username.value;
        // if(o['user_name']==null){
        //   o['user_name']="No Cashier";
        // }
        if(o['cashier']==null){
          o['cashier']=o["user_name"];
        }
        
        // else{
        //   o['cashier']=o["user_name"];
        // }
        u.push(o['cashier']);
      });
  
      let unique_pos =u.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      let unique_percentage=[];
      var unique_revenue=[];
     
        for(var i=0;i<unique_pos.length;i++){
          var to=0;
          var r=0;
          for(var a=0;a<objs.length;a++){
            if(objs[a]['cashier']==unique_pos[i]){ 
              r=r+parseInt(objs[a]['total_amount']);
              to=to+parseInt(objs[a]['total_tickets']);
            }
          }
          unique_percentage.push(to);
          unique_revenue.push(r);
        }
      
        setAmounts(unique_percentage);
        setLabels(unique_pos);
        setRevenue(unique_revenue)
  
  
       setTotalTickets(tic);
      setTotalAmount(tot);
      setReports(objs);
      setFilterDialog(false);
    }
  
   })
   .catch(err=>{
  
    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  
   });

    }else if(startDate.value<endDate.value || startDate.val>endDate.value){

      // duration 
      axios.defaults.baseURL = new ReportingService().BASE_URL;
      const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
      filterInstance.post('/extra-reports/pullUserReportLevelOne',{
       "company_id":new UserInfo().ORG_ID,
       "organization_id":new UserInfo().ORG_ID,
       "user":username.value,
       "end_date": endDate.value,
       "start_date": startDate.value,
       "username": username.value
   })
   .then(res=>{
    console.log("user report",res.data.data);
    setReportLoad(false);
    var objs=res.data.data;
    if(objs.length==0){
      
      setTotalAmount(0);
      setTotalTickets(0);
      setReportsMessage("No User report available");
      setFilterDialog(false);
    }else{
      var tot=0;
      var tic=0;
      var u=[];
      
      objs.map((o)=>{
        o['amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency'];
        tot=tot+parseInt(o['total_amount']);
        tic=tic+parseInt(o['total_tickets']);
        o['total_amount']=o['total_amount']+" "+o['currency'];
        o['user_name']=username.value;
        o['cashier']=username.value;
        // if(o['user_name']==null){
        //   o['user_name']="No Cashier";
        // }

        if(o['cashier']==null){
          o['cashier']=o["user_name"];
        }
        
        // else{
        //   o['cashier']=o["user_name"];
        // }
        u.push(o['cashier']);
      });
  
      let unique_pos =u.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      let unique_percentage=[];
      var unique_revenue=[];
     
        for(var i=0;i<unique_pos.length;i++){
          var to=0;
          var r=0;
          for(var a=0;a<objs.length;a++){
            if(objs[a]['cashier']==unique_pos[i]){ 
              r=r+parseInt(objs[a]['total_amount']);
              to=to+parseInt(objs[a]['total_tickets']);
            }
          }
          unique_percentage.push(to);
          unique_revenue.push(r);
        }
      
        setAmounts(unique_percentage);
        setLabels(unique_pos);
        setRevenue(unique_revenue)
  
  
      setReportTitle("User: "+username.value+" From : "+startDate.value+" To: "+endDate.value);
      setTotalTickets(tic);
      setTotalAmount(tot);
      setReports(objs);
      setFilterDialog(false);
    }
  
   })
   .catch(err=>{
  
    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  
   });

    }
   
  }else{
    console.log("==== all report ====");
    setReports([]);
    setAmounts([]);
    setLabels([]);
    setRevenue([]);
    // user_performance.options.series=[];
    // user_performance.options.labels=[];




    if(startDate.value==endDate.value){

      // one day  all users
      axios.defaults.baseURL = new ReportingService().BASE_URL;
      const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    filterInstance.post('/pos-report/user-daily-ticket-old',{
      "company_id":new UserInfo().ORG_ID,
      "organization_id":new UserInfo().ORG_ID,
      // "end_date": "2021-09-12 23:59:59",
      // "start_date": "2021-08-12 00:00:00"
      "end_date": endDate.value+" 23:59:59",
       "start_date": startDate.value+" 00:00:00"
 }
 ).then(res=>{
  console.log("all user report",res.data.data);
  setReportLoad(false);
  setReportTitle("All POS User  Day : "+startDate.value);
  var objs=res.data.data;
  if(objs.length==0){
    
    setTotalAmount(0);
    setTotalTickets(0);
    setReportsMessage("No User report available");
    setFilterDialog(false);
  }else{
    var tot=0;
    var tic=0;
    var u=[];
    

    objs.map((o)=>{
      o['amount']=formatMoney(parseInt(o['total_amount']),0)+" RWF";
      tot=tot+parseInt(o['total_amount']);
      tic=tic+parseInt(o['total_tickets']);
      o['total_amount']=o['total_amount']+" RWF";
      // if(o['user_name']==null){
      //   o['user_name']="No Cashier";
      // }
      if(o['cashier']==null){
        o['cashier']= o['user_name'];
      }
      
      // else{
      //   o['cashier']= o['user_name'];
      // }
      u.push(o['cashier']);
    });

    

    let unique_pos =u.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
    let unique_percentage=[];
    var unique_revenue=[];
     
        for(var i=0;i<unique_pos.length;i++){
          var to=0;
          var r=0;
          for(var a=0;a<objs.length;a++){
            if(objs[a]['cashier']==unique_pos[i]){
              r=r+parseInt(objs[a]['total_amount']);
              to=to+parseInt(objs[a]['total_tickets']);
            }
          }
          unique_percentage.push(to);
          unique_revenue.push(r);
        }


        setAmounts(unique_percentage);
        setLabels(unique_pos);
        setRevenue(unique_revenue);


        // user_performance.options.series=unique_percentage;
        // user_performance.options.labels=unique_pos;

        console.log("percentage",unique_percentage);

      console.log("distinct",unique_pos);


     setTotalTickets(tic);
    setTotalAmount(tot);
    setReports(objs);
    setFilterDialog(false);
  }

    })
    .catch(err=>{
      setReportLoad(false);

      if(err.message){
        setReportsMessage(err.message);
        enqueueSnackbar(err.message,
          { 
            variant: 'error'
        });
      }
  
      if(err.response){
        setReportsMessage(err.response.data.message);
        enqueueSnackbar(err.response.data.message,
          { 
            variant: 'error'
        });
      }
   
    });

    }else if(startDate.value<endDate.value || startDate.value>endDate.value){

      // duration  all users
      axios.defaults.baseURL = new ReportingService().BASE_URL;
      const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
      filterInstance.post('/pos-report/user-daily-ticket-old',{
        "company_id":new UserInfo().ORG_ID,
        "organization_id":new UserInfo().ORG_ID,
        // "end_date": "2021-09-12 23:59:59",
        // "start_date": "2021-08-12 00:00:00"
        "end_date": endDate.value+" 23:59:59",
         "start_date": startDate.value+" 00:00:00"
   }
   ).then(res=>{
    console.log("all user report",res.data.data);
    setReportLoad(false);
    var objs=res.data.data;
    if(objs.length==0){
      
      setTotalAmount(0);
      setTotalTickets(0);
      setReportsMessage("No User report available");
      setFilterDialog(false);
    }else{
      var tot=0;
      var tic=0;
      var u=[];
      
  
      objs.map((o)=>{
        o['amount']=formatMoney(parseInt(o['total_amount']),0)+" RWF";
        tot=tot+parseInt(o['total_amount']);
        tic=tic+parseInt(o['total_tickets']);
        o['total_amount']=formatMoney(parseInt(o['total_amount']),0)+" RWF";
        // if(o['user_name']==null){
        //   o['user_name']="No Cashier";
        // }
        if(o['cashier']==null){
          o['cashier']= o['user_name'];
        }
        
        // else{
        //   o['cashier']= o['user_name'];
        // }
        u.push(o['cashier']);
      });
  
      
  
      let unique_pos =u.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      let unique_percentage=[];
      var unique_revenue=[];
       
          for(var i=0;i<unique_pos.length;i++){
            var to=0;
            var r=0;
            for(var a=0;a<objs.length;a++){
              if(objs[a]['cashier']==unique_pos[i]){
                r=r+parseInt(objs[a]['total_amount']);
                to=to+parseInt(objs[a]['total_tickets']);
              }
            }
            unique_percentage.push(to);
            unique_revenue.push(r);
          }
  
  
          setAmounts(unique_percentage);
          setLabels(unique_pos);
          setRevenue(unique_revenue);
  
  
          // user_performance.options.series=unique_percentage;
          // user_performance.options.labels=unique_pos;
  
          console.log("percentage",unique_percentage);
  
        console.log("distinct",unique_pos);
  
  
      setReportTitle("All POS User  From : "+startDate.value+" To: "+endDate.value);
      setTotalTickets(tic);
      setTotalAmount(tot);
      setReports(objs);
      setFilterDialog(false);
    }
  
      })
      .catch(err=>{
        setReportLoad(false);
        if(err.message){
          setReportsMessage(err.message);
          enqueueSnackbar(err.message,
            { 
              variant: 'error'
          });
        }
    
        if(err.response){
          setReportsMessage(err.response.data.message);
          enqueueSnackbar(err.response.data.message,
            { 
              variant: 'error'
          });
        }
       
      });
    }
  }
}


// format money 

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};



// details report daily 

const [detailsMessage,setDetailsMessage]=useState("Loading");


const columns1 = [

  {
    name: "user_name",
    label: "Cashier",
    options: {
     filter: true,
     sort: true,
    }
   }
  ,
  {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "source",
   label: "Source",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "destination",
   label: "Destination",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "total_tickets",
    label: "Total tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
     name: "total_amount",
     label: "Total Amount",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "currency",
      label: "Currency",
      options: {
       filter: true,
       sort: true,
       display:false
      }
     }
 ];

 
 const options1 = {textLabels: {
  body: {
    noMatch: detailsMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
   selectableRowsOnClick: true,
   onCellClick: (cellData, cellMeta) => {
    var obj = detailsReport[cellMeta.dataIndex];
    get_details_two(obj.user_name,obj.source,obj.destination);
  },
 };



//user detailed report dialog

const [detailsdDialog,setDetailsDialog]=useState(false);

// user details report 


const [posUser,setPosUser]=useState("");

const [detailsLoad,setDetailsLoad]=useState(false);

const [detailsReport,setDetailsReport]=useState([]);
const get_details=(user)=>{
  setDetailsReport([]);
  setDetailsMessage("No report found!");
  setDetailsLoad(true);
  setDetailsDialog(true);

  var data={};

  if(startDate.value==endDate.value){
data={
  "company_id":new UserInfo().ORG_ID,
  "username":user,
  "end_date": endDate.value,
  "start_date": startDate.value
  };
  }else{
    data={
      "company_id":new UserInfo().ORG_ID,
      "username":user,
      "end_date": endDate.value,
      "start_date": startDate.value
      // "start_date":startDate.value,
      // "end_date":endDate.value,
      };
  }

  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const detailsInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  detailsInstance.post('/extra-reports/pullUserReportLevelOne',data)
  .then(res=>{
    var objs=res.data.data;
    if(objs.length==0){
      setDetailsMessage("No report found!");
    }else{
      let i=1;
      objs.map((o)=>{
        o['id']=i;
        o['user_name']=user;
        // o['total_amount']= formatMoney(parseInt(o['total_amount']),0)+" "+o['currency']; 
        o['total_amount']= formatMoney(parseInt(o['total_amount']),0)+" RWF"; 
      });
      setDetailsReport(objs);
    }
    
    setDetailsLoad(false);
  })
  .catch(err=>{
    setDetailsLoad(false);
  });
}





// user details report level two columns




const [detailsMessageTwo,setDetailsMessageTwo]=useState("No report available");


const columns2 = [
  
  {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "source",
   label: "Source",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "destination",
   label: "Destination",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "scheduling_time",
    label: "Schedule Time",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
     name: "plate_no",
     label: "Plate Number",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "total_tickets",
      label: "Total Tickets",
      options: {
       filter: true,
       sort: true,
      }
     },
 ];

 
 const options2 = {textLabels: {
  body: {
    noMatch: detailsMessageTwo
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
   selectableRowsOnClick: true,
   onCellClick: (cellData, cellMeta) => {
    var obj = detailsTwoReport[cellMeta.dataIndex];
    get_details_three(obj.destination,obj.source,obj.plate_no,obj.scheduling_time);
  },
 };




// user details report level two 




const [detailsTwoLoad,setDetailsTwoLoad]=useState(false);
const [detailsTwoDialog,setDetailsTwoDialog]=useState(false);
const [detailsTwoReport,setDetailsTwoReport]=useState([]);

const get_details_two=(user,source,destination)=>{
  setDetailsTwoLoad(true);
  setDetailsTwoDialog(true);
  setDetailsTwoReport([]);
  
  var data=
    {
      "company_id": new UserInfo().ORG_ID,
      "destination": destination,
      "source": source,
      "end_date": endDate.value+" 23:59:00",
      "start_date": startDate.value+" 00:00:00",
      // "start_date":startDate.value,
      // "end_date":endDate.value,
      "username":user
    };


  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const detailsInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  detailsInstance.post('/extra-reports/pullUserReportLevelTwo',data)
  .then(res=>{
    var objs=res.data.data;
    // console.log("level two");
    // console.log(objs);
    if(objs.length==0){
      setDetailsMessageTwo("No report found!");
    }else{
      setDetailsTwoReport(objs);
    }
    setDetailsTwoLoad(false);
  })
  .catch(err=>{
    setDetailsTwoLoad(false);
  });



}



// table user report level three column 



const [detailsMessageThree,setDetailsMessageThree]=useState("No report available");


const columns3 = [
  
  {
    name: "ticketId",
    label: "Ticket ID",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "source",
   label: "Source",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "destination",
   label: "Destination",
   options: {
    filter: true,
    sort: true,
   }
  },
  // {
  //   name: "departureTime",
  //   label: "Schedule Time",
  //   options: {
  //    filter: true,
  //    sort: true,
  //   }
  //  },
   {
     name: "passenger",
     label: "Passenger",
     options: {
      filter: true,
      sort: true,
     }
    },

    {
      name: "price",
      label: "Price",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "currency",
      label: "Currency",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "departureTime",
      label: "Departure Time",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "deviceSerialNr",
      label: "Serial Number",
      options: {
       filter: true,
       sort: true,
      }
     }
 ];

 
 const options3 = {textLabels: {
  body: {
    noMatch:detailsMessageThree
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
   selectableRowsOnClick: false
 };




// get user report level three 



const [detailsThreeLoad,setDetailsThreeLoad]=useState(false);
const [detailsThreeDialog,setDetailsThreeDialog]=useState(false);
const [detailsThreeReport,setDetailsThreeReport]=useState([]);



const get_details_three=(destination,source,plate_n,schedule_time)=>{
  setDetailsThreeReport([]);
  setDetailsThreeLoad(true);
  setDetailsThreeDialog(true);

  var data={
    "company_id":new UserInfo().ORG_ID,
    "destination":destination,
    "number_plate":plate_n,
    "scheduling_time":schedule_time,
    "source":source,
    // "start_date":startDate.value,
    // "end_date":endDate.value,
    "end_date": endDate.value+" 23:59:00",
    "start_date": startDate.value+" 00:00:00",
    "username": posUser
  };


  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const detailsInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  detailsInstance.post('/extra-reports/pullUserReportLevelThree',data)
  .then(res=>{
    var objs=res.data.data;
    console.log("level three");
    console.log(objs);
    if(objs.length==0){
      setDetailsMessageThree("No report found!");
    }else{
      setDetailsThreeReport(objs);
    }
    setDetailsThreeLoad(false);
  })
  .catch(err=>{
    setDetailsThreeLoad(false);
  });

}



  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><ConfirmationNumber fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>User Report</b></Typography>

 </Box>

 <Button 
color="primary" 
variant="outlined"
startIcon={<FilterList />}
onClick={()=>{
    setUsername({value:null,error:""});
    setFilterDialog(true); 
}}
>
     Filter
</Button>

</Box>


<Box mt={2}>
    <Grid container spacing={2}>
    <Grid item xs={12} md={12}>

          <Paper className={classes.paper1} elevation={0}>
            <Grid container>
              <Grid item xs={12} md={12}>
<Box display="flex" justifyContent="center"><Typography variant="h6">{reportTitle}</Typography></Box>
              </Grid>
              <Grid item xs={12} md={12}>
              <Chart options={revenue_user.options} series={revenue_user.options.series} type="bar"  height="300px"  />
              </Grid>
              </Grid>
              </Paper>
        </Grid>

        <Grid item md={8} lg={8} sm={12} xs={12}>
        {reportLoad&&<LinearProgress/>}
<MUIDataTable
  title={reportTitle}
  data={reports}
  columns={columns}
  options={options}
/>
        </Grid>
        <Grid item md={4} lg={4} sm={12} xs={12}>
            {reportLoad?
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
            <Grid item xs={12} md={12}>
              <Box><Typography variant="h6" className={classes.title}>Cashier Performance</Typography></Box>
            </Grid>
  
  
            <Grid item xs={12} md={12}>
  
            <Grid item lg={12} sm={12}  xs={12} md={12}>
                <Box >
                    <Box display="flex" justifyContent="center">
                    <Skeleton animation="wave" variant="circle" width={200} height={200} />
                    </Box>
                </Box>            

              </Grid>
  
            </Grid>
  
  
             </Grid>   
            </Paper>
    
            :
                <Paper className={classes.paper} elevation={0}>
                <Grid container>
                <Grid item xs={12} md={12}>
                   <Box><Typography variant="h6" className={classes.title}>Cashier Performance</Typography></Box>
                 </Grid>
      
      
                 <Grid item xs={12} md={12}>
      
                 <Grid item md={12} lg={12} xs={6} justify="left" md={8}>
                <Chart options={user_performance.options} series={amounts} type="pie" width={"100%"} height={"100%"} />
               </Grid>
      
                 </Grid>

                     <Grid item md={6} xs={6} sm={6} lg={6}>
                         <Grid container>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
                             <Typography>Total Tickets </Typography>
                             </Grid>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
            <Typography variant="h5">{totalTickets}</Typography> 
                             </Grid>

                         </Grid>
                         
                     </Grid>
                     <Grid item md={6} xs={6} sm={6} lg={6}>
                     <Grid container>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
                             <Typography>Total Amount </Typography>
                             </Grid>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
            <Typography variant="h5">{formatMoney(totalAmount,0)+" "+currency} </Typography> 
                             </Grid>

                         </Grid>
                     </Grid>
      
      
                  </Grid>   
                 </Paper>
              
             }
    
            </Grid>
    </Grid>

</Box> 

 </div>

{/* filter dialog  */}




<Dialog
    maxWidth="sm"
    fullWidth
        open={filterDialog}
        onClose={()=>{
            setFilterDialog(true);
        }}
        aria-labelledby="filter"
        aria-describedby="filter"
      >
        <DialogTitle id="filter">{"Filter"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
              <Box mt={1}>

          <Autocomplete
          size="small"
      options={users}
      getOptionLabel={(option) => option.names}
      fullWidth
      onChange={(event, newValue) => {

        if(newValue!=null){
          if(newValue.names.toLowerCase()=="All Users".toLowerCase()){
            setUsername({value:null,error:""});
         }else{
             setUsername({value:newValue.username,error:""});
         }
        }
       
      }}
      renderInput={(params) => <TextField {...params} label="Select User" variant="outlined" />}
    />
              </Box>
         
          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            
                            autoOk
                            label="Start date"
                            value={startDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen1: ", Format(v, ["yyyy-MM-dd",]));
                               
                                setStartDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
        
          </Box>
          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            
                            autoOk
                            label="End date"
                            value={endDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen2: ",v);
                                setEndDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
            </Box>

          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
              setFilterDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


            
          <Button onClick={()=>{

            filter_report();

          }} color="primary" variant="contained" className={classes.btn}>
              {reportLoad?<CircularProgress size={25} color="secondary"/>:
              <Typography>View</Typography>
              }
          </Button>


        </DialogActions>
         </Dialog>

{/* user daily detailed report  */}





<Dialog fullScreen open={detailsdDialog} style={{marginTop:"80px"}}  onClose={()=>{
   
  }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={()=>{
                 setDetailsDialog(false);
  }} aria-label="close">
                <Close />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Tickets
              </Typography>
  
              <Button autoFocus color="inherit" onClick={()=>{
               setDetailsDialog(false);
  
  }}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
  
          <Box mt={2}>
  {detailsLoad&&<LinearProgress />}
  <MUIDataTable
    title={"User >"+posUser}
    data={detailsReport}
    columns={columns1}
    options={options1}
  /> 
  </Box>  
  
  </Dialog>
  
  

{/* user daily detailsd report level two */}



<Dialog fullScreen open={detailsTwoDialog} style={{marginTop:"80px"}}  onClose={()=>{
   
  }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={()=>{
                setDetailsTwoDialog(false);
  }} aria-label="close">
                <Close />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Tickets
              </Typography>
  
              <Button autoFocus color="inherit" onClick={()=>{
                setDetailsTwoDialog(false);
  
  }}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
  
          <Box mt={2}>
  {detailsTwoLoad&&<LinearProgress />}
  <MUIDataTable
    title={"User >"+posUser}
    data={detailsTwoReport}
    columns={columns2}
    options={options2}
  /> 
  </Box>  
  
  </Dialog>
  
  

{/* user daily detailed report level three */}
  

<Dialog fullScreen open={detailsThreeDialog} style={{marginTop:"80px"}}  onClose={()=>{
   
  }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={()=>{
                setDetailsThreeDialog(false);
  }} aria-label="close">
                <Close />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Tickets
              </Typography>
  
              <Button autoFocus color="inherit" onClick={()=>{
                setDetailsThreeDialog(false);
  
  }}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
  
          <Box mt={2}>
  {detailsThreeLoad&&<LinearProgress />}
  <MUIDataTable
    title={"User >"+posUser}
    data={detailsThreeReport}
    columns={columns3}
    options={options3}
  /> 
  </Box>  
  
  </Dialog>
  


 </MuiPickersUtilsProvider>
  );
}

export default withLocalize(ReportUserOld);
